import { LionMark } from "./LionMark";

export const Footer = () => (
  <footer
    data-testid="main-footer"
    className="bg-[#121210] text-[#8C877D] py-14 px-8 border-t border-[#262522]"
  >
    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 font-grotesk text-xs">
      <div className="flex items-center gap-3">
        <LionMark className="w-7 h-7 text-[#9E7D4E]" />
        <div>
          <span className="font-editorial text-sm uppercase text-white font-semibold block">
            tseyaakuku.com
          </span>
          <span className="block text-[11px] text-[#635F57] mt-0.5">
            Born to Grow • Otjiwarongo, Namibia
          </span>
        </div>
      </div>
      <div>Hindenburg Street • Tel: +264 81 295 5979</div>
      <div className="text-[11px] text-[#635F57]">&copy; tseyaakuku.com. All rights reserved.</div>
    </div>
  </footer>
);
